import { post, get } from '@/utils/request';

export const getPurchaseDouyinSignature = params => get('purchase/douyin/signature/get', params);

// 获取抖音用户信息
export const getPurchaseDouyinUserinfo = params => get('purchase/douyin/userinfo/get', params);


// 判断是否可以继续授权
export const getPurchaseDouyinAthorization = params => get('purchase/douyin/authorization/flag', params);